<template>
  <v-sheet :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'">
    <v-container class="main-container responsive-height">
      <v-row dense>
        <v-col cols="12" xl="12">
          <v-card
            elevation="0"
            class="all-trade-tab rounded-0 ma-0 px-3 py-5"
            :class="$vuetify.theme.dark ? 'blue-darken-2' : 'transparent'"
          >
            <div
              style="
                display: flex;
                align-items: flex-end;
                justify-content: flex-end;
              "
            >
              <v-btn
                tile
                small
                elevation="0"
                class="text-capitalize btn-account"
                color="teal-lighten-1"
                @click="downloadExcel"
              >
                <span style="color: #131C29;">
                  <v-icon left color="#162334">mdi-download</v-icon>
                  {{
                    this.activeTab === 0
                      ? "Live Trades Excel"
                      : "Closed Trades Excel"
                  }}
                </span>
              </v-btn>
            </div>
            <v-tabs
              v-model="activeTab"
              :background-color="
                $vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'
              "
              class="pa-0"
            >
              <v-tab @click="handleTabClick(0)" class="ml-0">
                Live Trades</v-tab
              >
              <v-tab @click="handleTabClick(1)"> Closed Trades </v-tab>
              <v-tab-item>
                <v-card flat class="mb-0">
                  <LiveTradesTab></LiveTradesTab>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat class="mb-0">
                  <CloseTradesTab></CloseTradesTab>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import CloseTradesTab from "@/components/MyClients/TradingHistory/CloseTradesTab.vue";
import LiveTradesTab from "@/components/MyClients/TradingHistory/LiveTradesTab.vue";

import { mapState, mapActions } from "vuex";
import { TRADINGHISTORY__ACTIONS } from "@/store/action-types";
import * as XLSX from "xlsx";

export default {
  data: () => ({
    activeTab: 0,
  }),
  components: {
    LiveTradesTab,
    CloseTradesTab,
  },
  computed: {
    ...mapState("tradingHistory", [
      "live_trades_history",
      "closed_trades_history",
    ]),
  },
  methods: {
    ...mapActions("tradingHistory", [
      TRADINGHISTORY__ACTIONS.CLIENTCLOSEDTRADESREPORTS,
      TRADINGHISTORY__ACTIONS.CLIENTLIVETRADESREPORTS,
    ]),

    handleTabClick(index) {
      this.activeTab = index;
    },

    downloadExcel() {
      if (this.activeTab === 0) {
        const wb = XLSX.utils.book_new();
        const liveTradesData = this.live_trades_history?.trades;
        const earningDetails = this.live_trades_history?.totalProfit;

        // Rename keys in commission data objects
        const modifiedliveTradesData = liveTradesData.map((item) => ({
          Account: item.Login,
          Ticket: item.Position_ID,
          Time: item.TimeCreate,
          Lots: item.Volume / 10000,
          Symbol: item.Symbol,
          "Open Price": item.PriceOpen,
          "Closed Price": item.PriceCurrent,
          Type: item.Action === 0 ? "Buy" : "Sell",
          Profit: item.Profit,
        }));

        const ws = XLSX.utils.json_to_sheet(modifiedliveTradesData);
        XLSX.utils.book_append_sheet(wb, ws, "Live Trades Data");
        const totalRow = modifiedliveTradesData.length + 2;

        ws[`H${totalRow}`] = {
          t: "s",
          v: `Total`,
          s: { font: { bold: true } },
        };

        ws[`I${totalRow}`] = {
          t: "s",
          v: `${parseFloat(earningDetails)}`,
          s: { font: { bold: true } },
        };

        ws["!ref"] = XLSX.utils.encode_range({
          s: { c: 0, r: 0 },
          e: { c: 9, r: totalRow },
        });

        XLSX.writeFile(wb, "live_trades_data.xlsx");
      } else if (this.activeTab === 1) {
        const wb = XLSX.utils.book_new();
        const closedTradesData = this.closed_trades_history?.trades;
        const earningDetails = this.closed_trades_history?.totalProfit;

        // Rename keys in commission data objects
        const modifiedClosedTradesData = closedTradesData.map((item) => ({
          Account: item.Login,
          Ticket: item.PositionID,
          Time: item.Time,
          Lots: item.Volume / 10000,
          Symbol: item.Symbol,
          "Open Price": item.Price,
          "Closed Price": item.PricePosition,
          Type: item.Action === 0 ? "Buy" : "Sell",
          Profit: item.Profit,
        }));

        const ws = XLSX.utils.json_to_sheet(modifiedClosedTradesData);
        XLSX.utils.book_append_sheet(wb, ws, "Closed Trades Data");
        const totalRow = modifiedClosedTradesData.length + 2;

        ws[`H${totalRow}`] = {
          t: "s",
          v: `Total`,
          s: { font: { bold: true } },
        };

        ws[`I${totalRow}`] = {
          t: "s",
          v: `${parseFloat(earningDetails)}`,
          s: { font: { bold: true } },
        };

        ws["!ref"] = XLSX.utils.encode_range({
          s: { c: 0, r: 0 },
          e: { c: 9, r: totalRow },
        });

        XLSX.writeFile(wb, "close_trades_data.xlsx");
      }
    },
  },
  async mounted() {
    this[TRADINGHISTORY__ACTIONS.CLIENTCLOSEDTRADESREPORTS]();
    this[TRADINGHISTORY__ACTIONS.CLIENTLIVETRADESREPORTS]();
  },
};
</script>
